module.exports = __webpack_public_path__ + "static/leftHeadphones-26fe4a54df2b630fa713a33052be2e9e.svg";